import { atlasBackendApi } from '../api/atlasBackendClient';

import { getAtlasApiBaseUrl } from '../getAtlasApiBaseUrl';
import { CreateRouteOverlapRunRequest, RouteOverlapRun } from './types';

const API_BASE = `${getAtlasApiBaseUrl()}/api/network`;

function getAuthToken(): string {
  const tokenString = localStorage.getItem('atlas_authToken');
  if (!tokenString) {
    throw new Error('No authentication token found. Please log in first.');
  }
  try {
    const parsed = JSON.parse(tokenString);
    if (parsed?.access_token) {
      return parsed.access_token;
    }
  } catch {
    // Not JSON; use the raw string.
  }
  return tokenString;
}

function authHeaders(): Record<string, string> {
  return { Authorization: `Bearer ${getAuthToken()}` };
}

export async function createRouteOverlapRun(
  feedId: string,
  request: CreateRouteOverlapRunRequest,
): Promise<RouteOverlapRun> {
  const response = await atlasBackendApi.post<RouteOverlapRun>(
    `${API_BASE}/feeds/${encodeURIComponent(feedId)}/route-overlap-runs`,
    request,
    {
      headers: authHeaders(),
      timeout: 15000,
    },
  );
  return response.data;
}

export async function getRouteOverlapRun(feedId: string, runId: string): Promise<RouteOverlapRun> {
  const response = await atlasBackendApi.get<RouteOverlapRun>(
    `${API_BASE}/feeds/${encodeURIComponent(feedId)}/route-overlap-runs/${encodeURIComponent(runId)}`,
    {
      headers: authHeaders(),
      timeout: 15000,
    },
  );
  return response.data;
}

export async function cancelRouteOverlapRun(feedId: string, runId: string): Promise<RouteOverlapRun> {
  const response = await atlasBackendApi.post<RouteOverlapRun>(
    `${API_BASE}/feeds/${encodeURIComponent(feedId)}/route-overlap-runs/${encodeURIComponent(runId)}/cancel`,
    {},
    {
      headers: authHeaders(),
      timeout: 15000,
    },
  );
  return response.data;
}
